import { Duration } from 'luxon';
import { formatBytes } from '~/lib/units';

type MaybeNumber = number | null | undefined;

export const displaySpace = (available: MaybeNumber, total: MaybeNumber, none = 'N/A') => {
  if (!available || !total) return none;
  return `${formatBytes(total - available)} / ${formatBytes(total)}`;
};

export const displayTemperature = (celsius: MaybeNumber, none = 'N/A') => {
  if (!celsius) return none;
  const fahrenheit = (celsius * 9) / 5 + 32;
  return `${celsius}°C / ${fahrenheit}°F`;
};

export const formatUptime = (uptime: MaybeNumber) => {
  if (!uptime) return 'N/A';
  const options = { unitDisplay: 'narrow', type: 'unit' } as const;
  return Duration.fromObject({ seconds: uptime })
    .shiftTo('days', 'hours', 'minutes', 'seconds')
    .rescale()
    .toHuman(options);
};
